
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'Settings-text--privacy-policy'
})

export default class SettingsTextPrivacyPolicy extends Vue { }
